'use strict';

var TypeaheadController = require('./TypeaheadController');

exports.typeaheadController = new TypeaheadController();



// WEBPACK FOOTER //
// ./assets/components/Typeahead/index.js